import React from 'react';

import WelcomeScreen from 'views/scenes/welcome/WelcomeScreen';

const Welcome = (props) => {
  return (
    <>
      <WelcomeScreen

      />
    </>
  );
};

Welcome.propTypes = {
};

export default React.memo(Welcome);

